// extracted by mini-css-extract-plugin
module.exports = {"avatar":"embed-title-author_avatar_3fb","timeViewsRow":"embed-title-author_timeViewsRow_29v"};